<div class="ui basic modal-content" style="border: none !important;">
    <div class="header">
        <h3>{{modal.context.title}}</h3>
        <img src="assets/icons/close-sm.svg" alt="" (click)="modal.deny(undefined)">
    </div>
    <div class="content">
        <p>{{modal.context.data.operation === 'whitelist' ? 
            'Are you sure you want to whitelist this IP Address, ' : 
            'Are you sure you want to blacklist this IP Address, '}} {{modal.context.data.ipAddress}}</p>
    </div>
    <div class="ctrl-btns">
        <button class="cancel" (click)="modal.deny(undefined)">Cancel</button>
        <button class="delete" (click)="operation()" [class.loading]="pending">Yes</button>
    </div>
</div>